import React from 'react';
import { Menu, Tooltip } from 'antd';
import COLORS from '../../util/constants/colors';
import getChartActionItems, { chartActionPropTypes, chartActionDefaultProps } from './chartActionItems';
import './chartActionsMenu.scss';

// Disabled items keep the reason in a tooltip because antd clips menu-item text.
const ChartActionsMenu = (props) => (
  <Menu className="chart-actions-menu" selectable={false}>
    {getChartActionItems(props).map((action) => (action.visible ? (
      <Menu.Item
        key={action.key}
        onClick={action.handler}
        disabled={action.disabled}
        data-tutorial={action.tutorial}
      >
        <span className="dropdown-icon">
          <action.Icon size={20} weight={action.iconWeight} color={COLORS.PURPLE_PRIMARY_LITE} />
        </span>
        <Tooltip title={action.disabled ? props.disabledExplanation : undefined} placement="left">
          <span className="chart-menu-item-text"><span>{action.label}</span></span>
        </Tooltip>
      </Menu.Item>
    ) : null))}
  </Menu>
);

ChartActionsMenu.propTypes = chartActionPropTypes;
ChartActionsMenu.defaultProps = chartActionDefaultProps;

export default ChartActionsMenu;
